import React from "react";
import styles from "./heading.module.css";
import { Box, Button, Typography, useTheme } from "@mui/material";

function Heading(props) {
  const theme = useTheme();
  return (
    <div className={styles.heading}>
      <Typography
        variant="h4"
        color={theme.palette.neutral[900]}
        fontWeight={700}
      >
        {props.title}
      </Typography>
      <Box sx={{display: "flex", gap: "12px"}} className={styles.buttons}>
        {props.secondaryButton &&  (
          <Button
            variant="outlined"
            onClick={props.onSecondaryButtonClick}
            sx={{ backgroundColor: "white" }}
          >
            {props.secondaryButton}
          </Button>
        )}
        {props.button && (
          <Button variant="contained" onClick={props.onButtonClick}>
            {props.button}
          </Button>
        )}
      </Box>
    </div>
  );
}

export default Heading;
